class NewsletterPopup extends HTMLElement {
    constructor() {
        super();

        this.popup = this;
        this.timeToShow = parseInt(this.popup.getAttribute('data-delay'));
        this.expiresDate = this.popup.getAttribute('data-expire');
        this.cookieName = this.popup.getAttribute('data-cookie') || 'newsletter-popup';
        const forcePreview = new URLSearchParams(window.location.search).get('early_dawn_preview') === '1';
        if (forcePreview || this.getCookie(this.cookieName) === ''){
            var popup = this.popup;

            setTimeout(function() {
                popup.removeAttribute('inert');
                popup.setAttribute('aria-hidden', 'false');
                document.body.classList.add('newsletter-show');
                if (!forcePreview) popup.setCookie(popup.cookieName, 'shown', popup.expiresDate);
                popup.previousFocus = document.activeElement;
            }, this.timeToShow);

            setTimeout(() => {
                if (!document.body.classList.contains('newsletter-show')) return;
                document.body.classList.add('show-newsletter-image');
                this.querySelector('[data-promo-link]')?.focus({ preventScroll: true });
            }, this.timeToShow + 700)
        } else {

        }
        
        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));

        this.querySelectorAll('[data-close-newsletter-popup]').forEach((button) => {
            button.addEventListener('click', this.setClosePopup.bind(this));
        });

        this.querySelector('#ContactPopup')?.addEventListener(
            'submit',
            this.setClosePopup.bind(this)
        );
        this.querySelector('[data-promo-dismiss]')?.addEventListener('click', this.setClosePopup.bind(this));
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && document.body.classList.contains('newsletter-show')) {
                this.setClosePopup();
            }
        });
        this.addEventListener('keydown', (event) => {
            if (event.key !== 'Tab' || !document.body.classList.contains('newsletter-show')) return;
            const controls = this.querySelectorAll('a[href],button,input:not([type="hidden"])');
            const first = controls[0];
            const last = controls[controls.length - 1];
            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        });
    }

    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        const expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }

    getCookie(cname) {
        const name = cname + '=';
        const ca = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }

        return '';
    }

    deleteCookie(name) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    setClosePopup() {
        this.setCookie(this.cookieName, 'closed', this.expiresDate);
        this.setAttribute('aria-hidden', 'true');
        this.setAttribute('inert', '');
        document.body.classList.remove('newsletter-show');
        if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
        setTimeout(() => {
            document.body.classList.remove('show-newsletter-image');
        }, 700)
    }

    onBodyClickEvent(event){
        if ((!this.contains(event.target)) && (!event.target.closest('[data-open-newsletter-popup]')) && document.querySelector('body').classList.contains('newsletter-show')){
            this.setClosePopup();
        }
    }
}

customElements.define('newsletter-popup', NewsletterPopup);

class NewsletterMessagePopup extends HTMLElement {
    constructor() {
        super();

        this.querySelector('[data-close-newsletter-message-popup]').addEventListener(
            'click',
            this.close.bind(this)
        );

        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
    }

    close(){
        document.body.classList.remove('newsletter-message-show');
    }

    onBodyClickEvent(event){
        if (!this.contains(event.target)){
            this.close();
        }
    }
}

customElements.define('newsletter-message-popup', NewsletterMessagePopup);
